<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="form-base__title step-name">Сведения о заявителе</div>

        <Subject
          :statement="statement"
          :subject="statement.subjects.applicant"
        />
      </v-col>
    </v-row>

    <v-row v-if="statement.documentConversionStep2">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Описание электронного документа, представляемого нотариусу для
          хранения
        </div>

        <Step2 :data="statement.documentConversionStep2" />
      </v-col>
    </v-row>

    <v-row v-if="statement.documentConversionStep3">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Формат электронного документа, в который осуществляется конвертация
        </div>

        <Step3 :data="statement.documentConversionStep3" />
      </v-col>
    </v-row>

    <v-row v-if="statement.documentConversionStep4">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Реквизиты счета для возврата заявителю суммы платежа за совершение
          нотариального действия в случае отказа в совершении нотариального
          действия
        </div>

        <StepRequisites
          :data="statement.documentConversionStep4"
          :statement-type="StatementType.DOCUMENT_CONVERSION"
        />
      </v-col>
    </v-row>

    <v-row v-if="statement.locationStep">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Выбор места совершения нотариального действия
        </div>

        <StepSign :data="statement.locationStep" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Subject from '@/components/elements/statement/FullStatementView/elements/Subject';
import Step2 from '@/components/elements/statement/FullStatementView/steps/DocumentConversion/Step2';
import Step3 from '@/components/elements/statement/FullStatementView/steps/DocumentConversion/Step3';
import StepRequisites from '@/components/elements/statement/FullStatementView/steps/common/StepRequisites';
import StepSign from '@/components/elements/statement/FullStatementView/steps/common/StepSign';
import { StatementType } from '@/types/services';

export default {
  name: 'DocumentConversion',
  components: {
    Subject,
    Step2,
    Step3,
    StepRequisites,
    StepSign,
  },
  props: {
    statement: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    StatementType,
  }),
};
</script>
